import React, { useEffect, useState } from "react";
import UserProfile from "../../Reuseable/UserProfile..jsx";
import { Link, useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import EvaluationService from "../../../Services/EvaluationService.js";
import DataParser from "../../../utlits/Dataparser";
import "react-loading-skeleton/dist/skeleton.css";
import TableSkeleton from "../../Reuseable/TableSkeleton";
import { message } from "antd";
import { paginate } from "../../../utlits/Paginate.js";
import Pagination from "../../Reuseable/Pagination";
import SocketService from "../../../Services/SocketService";
import { DatePicker } from "antd";
import moment from "moment";
const { RangePicker } = DatePicker;


const UserEvaluationTable = () => {
    const [List, setList] = useState([]);
    const [userPermissions, setuserPermissions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(15);
    const navigate = useNavigate();
    const [error, setError] = useState("");
    const [dateRangeFilter, setDateRangeFilter] = useState(null);
    const [remarksModal, setRemarksModal] = useState(false);
    const [currentRemarks, setCurrentRemarks] = useState("");

    // State for View Average Report
    const [showAverageTable, setShowAverageTable] = useState(false);

    const getAverageData = () => {
        if (filteredList.length === 0) return null;

        const sum = filteredList.reduce((acc, curr) => ({
            attendance: acc.attendance + Number(curr.attendancescore || 0),
            task: acc.task + Number(curr.taskscore || 0),
            manager: acc.manager + Number(curr.managerreviewscore || 0),
            total: acc.total + Number(curr.totalevaluation || 0)
        }), { attendance: 0, task: 0, manager: 0, total: 0 });

        return {
            user_name: filteredList[0]?.user_name || "Myself",
            attendance: sum.attendance / filteredList.length,
            task: sum.task / filteredList.length,
            manager: sum.manager / filteredList.length,
            total: sum.total / filteredList.length,
            count: filteredList.length
        };
    };

    useEffect(() => {
        if (pageSize > 10) {
            setCurrentPage(1);
        }
    }, [pageSize]);

    const handelPageChange = (e, page) => {
        e.preventDefault();
        setCurrentPage(page);
    };

    const loggedUser = JSON.parse(secureLocalStorage.getItem("adminInfo"));
    const loggedUserId = loggedUser?.user?.userdata?.id;

    const getData = () => {
        setIsLoading(true);
        const companyId = DataParser.CompanyId();

        EvaluationService.getevaluation(loggedUserId, companyId)
            .then((res) => {
                if (res.data === "Un-Athunticated request") {
                    message.error("Session expired! Please log in again.");
                    secureLocalStorage.removeItem("adminInfo");
                    secureLocalStorage.removeItem("admins");
                    navigate("/");
                    return;
                }

                const data = res.data.evaluations || [];
                // Sort descending to show latest evaluation period at the top
                const sortedData = data.sort((a, b) => {
                    const dateA = moment(a.periodstart, "DD MMM YYYY").valueOf();
                    const dateB = moment(b.periodstart, "DD MMM YYYY").valueOf();
                    return dateB - dateA;
                });

                setList(sortedData);
            })
            .catch((err) => {
                console.error("Error fetching list:", err);

            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    useEffect(() => {
        getData();
        const upermission = DataParser.CompanyUserPermissions();
        setuserPermissions(upermission);
    }, []);

    // 🟢 Socket Integration
    useEffect(() => {
        SocketService.connect();
        const companyId = DataParser.CompanyId();

        const handleEvaluationUpdate = (data) => {
            if (Number(data.company_id) === Number(companyId)) {
                console.log("🔔 Evaluation update received:", data);
                getData();
            }
        };

        SocketService.on("evaluation_update", handleEvaluationUpdate);

        return () => {
            SocketService.off("evaluation_update", handleEvaluationUpdate);
        };
    }, []);



    // Filter logic
    const getFilteredList = () => {
        if (!dateRangeFilter || !dateRangeFilter[0] || !dateRangeFilter[1]) {
            return List;
        }

        return List.filter(item => {
            const itemStart = moment(item.periodstart);
            const itemEnd = moment(item.periodend);
            const filterStart = dateRangeFilter[0];
            const filterEnd = dateRangeFilter[1];

            // Check if there is any overlap between evaluation period and selected filter period
            // OR if the evaluation period falls within the selected filter period
            // Adjust logic as per user requirement: "all the evaluations falls in that date period will be shown"
            // Usually this means if the evaluation start date is within the range.
            // Let's assume inclusive overlap or start date fall within.
            // "if someone select the date from the filter all the evaluations falls in that date period will be shown"
            // Simple logic: periodstart and periodend of evaluation should be within range?
            // Or if the evaluation period *overlaps* with the selected range?
            // "evaluations falls in that date period" usually suggests:
            // Filter: Jan 1 - Jan 31
            // Eval: Jan 15 - Feb 15 (Shown? Yes, probably)
            // Eval: Dec 15 - Jan 15 (Shown? Yes, probably)
            // Let's stick to: Evaluation Start >= Filter Start AND Evaluation End <= Filter End?
            // "evaluations falls in that date period" -> fully contained?
            // Re-reading user request: "all the evaluations falls in that date period will be shown... the evalautaion within the selected date will be shown"
            // This sounds like "Contained in".
            // However, often users want to see anything *touching* that period.
            // Let's implement generic overlap for now, or maybe just check Start Date.
            // Common pattern in this app seems to be simple date range checks.
            // Let's try: Evaluation Start Date OR Evaluation End Date is within the Filter Range.

            // Actually, for "Falls in that date period", usually means the record's date is inside the range.
            // Since evaluations have a period, let's use the period start date as the primary anchor.

            return (
                (itemStart.isSameOrAfter(filterStart, 'day') && itemStart.isSameOrBefore(filterEnd, 'day')) ||
                (itemEnd.isSameOrAfter(filterStart, 'day') && itemEnd.isSameOrBefore(filterEnd, 'day'))
            );
        });
    };

    const filteredList = getFilteredList();
    const averageData = getAverageData();
    const PaginatedData = paginate(filteredList, currentPage, pageSize);

    return (
        <>
            {/* <Sidebar /> */}
            <div className="main-content">
                <div className="page-content Pagebody" style={{ backgroundColor: "#fff", minHeight: "100vh" }}>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12 px-0">
                                <div className="d-flex align-items-center justify-content-end" style={{ padding: "0 0 12px 0" }}>

                                    <div className="d-flex align-items-center gap-2 flex-wrap">
                                        <style>{`
                                            /* Global Filter Row Styles with float-select-wrap support */
                                            .custom-filter.float-select-wrap .ant-picker {
                                                height: 34px !important;
                                                min-height: 34px !important;
                                                border-radius: 6px !important;
                                            }
                                            
                                            .custom-filter.float-select-wrap .ant-picker-input > input {
                                                line-height: 30px !important;
                                                font-size: 13px !important;
                                            }

                                            .custom-filter.float-select-wrap label {
                                                font-size: 11px !important;
                                                font-weight: 600 !important;
                                            }

                                            .ant-picker-range .ant-picker-active-bar {
                                                background: #1D1D1D !important;
                                            }

                                            /* Hover/focus on filter fields */
                                            .custom-filter.float-select-wrap:hover .ant-picker,
                                            .custom-filter.float-select-wrap .ant-picker-focused {
                                                border-color: #1D1D1D !important; box-shadow: none !important;
                                            }
                                            .custom-filter.float-select-wrap:hover label,
                                            .custom-filter.float-select-wrap:focus-within label { color: #1D1D1D !important; }
                                            .custom-filter.float-select-wrap:hover .ant-picker-suffix div,
                                            .custom-filter.float-select-wrap:focus-within .ant-picker-suffix div { background-color: #1D1D1D !important; }
                                            .custom-filter.float-select-wrap:hover .ant-picker-suffix div i,
                                            .custom-filter.float-select-wrap:focus-within .ant-picker-suffix div i { color: #fff !important; }

                                            /* Buttons synchronization */
                                            .eval-action-btn {
                                                height: 34px !important;
                                                border-radius: 6px !important;
                                                font-size: 13px !important;
                                                font-weight: 600 !important;
                                                padding: 0 15px !important;
                                                display: flex !important;
                                                align-items: center !important;
                                                justify-content: center !important;
                                                box-shadow: none !important;
                                            }
                                        `}</style>
                                        <div className={`float-select-wrap custom-filter ${(dateRangeFilter && dateRangeFilter.length > 0) ? "has-value" : ""}`} style={{ width: "280px", maxWidth: "280px" }}>
                                            <label>Evaluation Period</label>
                                            <RangePicker
                                                onChange={(dates) => setDateRangeFilter(dates)}
                                                value={dateRangeFilter}
                                                allowClear
                                                separator=""
                                                placeholder={['', '']}
                                                suffixIcon={
                                                    <div style={{
                                                        backgroundColor: "#F4F4F4",
                                                        borderRadius: "6px",
                                                        width: "24px",
                                                        height: "24px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        marginRight: "-4px"
                                                    }}>
                                                        <i className="uil-schedule" style={{ color: "#A0A0A0", fontSize: "15px" }} />
                                                    </div>
                                                }
                                            />
                                        </div>
                                        {showAverageTable ? (
                                            <button
                                                className="btn btn-outline-danger eval-action-btn"
                                                onClick={() => setShowAverageTable(false)}
                                            >
                                                <i className="uil-sync me-1"></i> Reset to List
                                            </button>
                                        ) : (
                                            <button
                                                className="btn btn-success eval-action-btn"
                                                style={{
                                                    backgroundColor: "#0DDFAB",
                                                    borderColor: "#0DDFAB",
                                                    color: "#fff"
                                                }}
                                                onClick={() => {
                                                    setShowAverageTable(true);
                                                    setCurrentPage(1);
                                                }}
                                            >
                                                View Average Report
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12 px-0">
                                <div className="card" style={{ backgroundColor: "#fff", boxShadow: "none", borderRadius: 0, border: "none" }}>
                                    <div className="card-body p-0">
                                        <div className="table-responsive listing-table-wrapper">
                                            <table className="table mb-0 custom-table listing-table">
                                                <thead className="text-center">
                                                    <tr className="tableHeaderbg text-start">
                                                        {showAverageTable && <th className="text-start">Name</th>}
                                                        {!showAverageTable && (
                                                            <>
                                                                <th className="text-start">Attendance Score</th>
                                                                <th className="text-start">Tasks Score</th>
                                                                <th className="text-start">Manager Review Score</th>
                                                            </>
                                                        )}
                                                        <th className="text-start">Total Score</th>
                                                        {!showAverageTable && (
                                                            <>
                                                                <th className="text-start">Evaluation Period</th>
                                                                <th className="text-start">Evaluated By</th>
                                                                <th className="text-start">Remarks</th>
                                                            </>
                                                        )}
                                                        {showAverageTable && <th className="text-start">Evaluations Count</th>}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {isLoading ? (
                                                        <TableSkeleton cols={12} rows={6} />
                                                    ) : (
                                                        <>
                                                            {showAverageTable ? (
                                                                <>
                                                                    {averageData ? (
                                                                        <tr className="text-start">
                                                                            <td className="tableset">{averageData.user_name}</td>
                                                                            <td className="tableset">
                                                                                <span className="badge bg-success" style={{ fontSize: "14px", padding: "6px 12px" }}>
                                                                                    {Number(averageData.total || 0).toFixed(2)}%
                                                                                </span>
                                                                            </td>
                                                                            <td className="tableset">
                                                                                {averageData.count} evaluation{averageData.count > 1 ? 's' : ''}
                                                                            </td>
                                                                        </tr>
                                                                    ) : (
                                                                        <tr>
                                                                            <td colSpan="12" className="text-center">
                                                                                No evaluation data found for averages.
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                <>
                                                                    {PaginatedData && PaginatedData.length > 0 ? (
                                                                        PaginatedData.map((item, index) => (
                                                                            <tr key={item.id} className="text-start">
                                                                                {/* <th className="tableset text-center" scope="row">
                                                                                    {index + 1}
                                                                                </th> */}
                                                                                <td className="tableset">{Number(item.attendancescore || 0).toFixed(2)}%</td>
                                                                                <td className="tableset">{Number(item.taskscore || 0).toFixed(2)}%</td>
                                                                                <td className="tableset">{Number(item.managerreviewscore || 0).toFixed(2)}%</td>
                                                                                <td className="tableset">{Number(item.totalevaluation || 0).toFixed(2)}%</td>
                                                                                <td className="tableset">{item.periodstart} - {item.periodend} </td>
                                                                                <td className="tableset">
                                                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                                        <UserProfile username={item.evaluationby_name} userImage={null} style={{ width: '22px', height: '22px' }} />
                                                                                        <span style={{ fontSize: '13px', color: '#1d1d1d', fontWeight: '500' }}>{item.evaluationby_name}</span>
                                                                                    </div>
                                                                                </td>
                                                                                <td className="tableset">
                                                                                    <button
                                                                                        className="btn btn-sm"
                                                                                        onClick={() => {
                                                                                            setCurrentRemarks(item.remarks || "No remarks provided.");
                                                                                            setRemarksModal(true);
                                                                                        }}
                                                                                    >
                                                                                        <i className="uil-eye" style={{ fontSize: "16px" }}></i>
                                                                                    </button>
                                                                                </td>
                                                                            </tr>
                                                                        ))
                                                                    ) : (
                                                                        <tr>
                                                                            <td colSpan="12" className="text-center">
                                                                                No Performance Evaluation found.
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                                </>
                                                            )}
                                                        </>
                                                    )}
                                                </tbody>
                                            </table>

                                            {!showAverageTable && filteredList.length > pageSize && (
                                                <div className="d-flex justify-content-center mt-4">
                                                    <Pagination
                                                        itemCount={filteredList.length}
                                                        currentPage={currentPage}
                                                        pageSize={pageSize}
                                                        onPageChange={handelPageChange}
                                                    />
                                                </div>
                                            )}
                                        </div>


                                        {/* Remarks Modal */}
                                        {remarksModal && (
                                            <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1055 }} tabIndex="-1" onClick={() => setRemarksModal(false)}>
                                                <div className="modal-dialog modal-dialog-centered" onClick={e => e.stopPropagation()}>
                                                    <div className="modal-content border-0 shadow-lg" style={{ borderRadius: "12px" }}>
                                                        <div className="modal-header border-0 pb-0">
                                                            <h5 className="modal-title fw-bold" style={{ color: "#0f223a" }}>Remarks</h5>
                                                            <button type="button" className="btn-close" onClick={() => setRemarksModal(false)}></button>
                                                        </div>
                                                        <div className="modal-body p-4 text-center">
                                                            <div className="mb-4">
                                                                <p className="text-muted mb-0" style={{ fontSize: "15px", lineHeight: "1.6" }}>
                                                                    {currentRemarks}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default UserEvaluationTable;
